import { useState } from "react";
import { Modal } from "react-bootstrap";

import { toAbsoluteUrl } from "../../_metronic/helpers";

/**
 * SafetyDisclaimerModal component for displaying a safety disclaimer popup.
 * - Renders a clickable card and modal with disclaimer text and image.
 * - Uses React Bootstrap Modal for display and manages open/close state.
 * - Customizable disclaimer text via props.
 */
const SafetyDisclaimerModal = ({ safetytext = " Some quick example text to build on the card title and make up the bulk of the card's content." }) => {
    const [show, setShow] = useState(true);


    return (
        <>
            <div
                className="card min-h-42px mt-3 w-100 rounded-2"
                style={{ backgroundColor: "#FBF6F7", border: "1px solid #d4d4d4", cursor: "pointer" }}
                onClick={() => setShow(true)}
            >
                <div className="card-body p-1 px-4 d-flex justify-content-between align-items-center">
                    <div className="text-start d-flex align-items-center">
                        <div className="d-flex align-items-center gap-4">
                            <i style={{ color: "#ED1C24" }} class="bi fs-2 bi-exclamation-triangle-fill"></i>
                            <div className="fw-semibold fs-2" style={{ color: "#ED1C24" }}>Safety Disclaimer</div>
                        </div>
                    </div>
                    <div className='pt-1'>
                        <i style={{ color: "#ED1C24" }} class="bi fs-2 bi-arrow-right-circle-fill"></i>
                    </div>
                </div>
            </div>
            <Modal
                show={show}
                centered

            >
                <div className="card-flush">
                    <img
                        src={toAbsoluteUrl('/media/images/disclaimer.png')}
                        className="card-img-top"
                        alt="Safety Disclaimer"
                    />
                    <div className="card-body p-5">
                        <p className="card-text text-center ">
                            {safetytext}
                        </p>
                        <div className="btn btn-dark w-100 mt-2" onClick={() => setShow(false)}>OK</div>
                    </div>
                </div>
            </Modal>
            <style jsx>{`
             .modal-content {
  border-radius: 22px;
  width: 90%;
  margin: 0 auto;
  background-color: #ECECEC;
.
.modal-backdrop.show {
opacity:--bs-backdrop-opacity: 0.9;

}
         
            `}</style>
        </>
    );
};

export default SafetyDisclaimerModal;
